const prefillWidget = () => {
  const userDataEl = document.getElementById("user-data-tag");
  if (!userDataEl) return;

  const userData = JSON.parse(userDataEl.textContent || "{}");
  if (!userData.email) return;

  try {
    zE("webWidget", "prefill", {
      name: { value: userData.name || "" },
      email: { value: userData.email }
    });
  } catch (e) {}
};

const widgetEnabledForCurrentPage = () => {
  const marker = document.getElementById("loomly-ai-main");
  if (marker && marker.dataset.zendeskWidgetEnabled !== undefined) {
    return marker.dataset.zendeskWidgetEnabled === "true";
  }

  return !!document.getElementById("ze-snippet");
};

const syncZendeskWidget = () => {
  if (!widgetEnabledForCurrentPage()) {
    try { zE("messenger", "hide"); } catch (e) {}
    try { zE("webWidget", "hide"); } catch (e) {}
    return;
  }

  window.zE = window.zE || function () { (zE.q = zE.q || []).push(arguments); };

  try { zE("messenger", "show"); } catch (e) {}
  try { zE("webWidget", "show"); } catch (e) {}
  prefillWidget();
};

$(document).on("turbo:load", syncZendeskWidget);

$(document).on("turbo:frame-load", (event) => {
  if (event.target && event.target.id === "loomly-ai-main-frame") {
    syncZendeskWidget();
  }
});
